module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1071.c9509250.png";